import { render, staticRenderFns } from "./NewsAppProCmpt.vue?vue&type=template&id=6912c2b8&scoped=true&"
import script from "./NewsAppProCmpt.vue?vue&type=script&lang=ts&"
export * from "./NewsAppProCmpt.vue?vue&type=script&lang=ts&"
import style0 from "./NewsAppProCmpt.vue?vue&type=style&index=0&id=6912c2b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6912c2b8",
  null
  
)

export default component.exports